import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormControl, ReactiveFormsModule, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  host: { 'class': 'w-full block' }
})
export class ChangePasswordComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  changePasswordForm = new FormGroup({
    password: new FormControl('', { validators: [Validators.required, Validators.minLength(8)], nonNullable: true }),
    confirmPassword: new FormControl('', { validators: [Validators.required], nonNullable: true })
  }, { validators: [this.passwordMatchValidator] });

  isLoading = false;
  errorMessage = '';
  passwordVisible = false;
  confirmPasswordVisible = false;
  
  uid = '';
  token = '';

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.uid = params['uid'] || '';
      this.token = params['token'] || '';
      if (!this.uid || !this.token) {
        this.errorMessage = 'Invalid password reset link. Please try again.';
      }
    });
  }

  passwordMatchValidator(g: AbstractControl) {
    return g.get('password')?.value === g.get('confirmPassword')?.value ? null : { mismatch: true };
  }

  togglePasswordVisibility(field: 'password' | 'confirm') {
    if (field === 'password') this.passwordVisible = !this.passwordVisible;
    if (field === 'confirm') this.confirmPasswordVisible = !this.confirmPasswordVisible;
  }

  onSubmit() {
    if (this.uid && this.token && this.changePasswordForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      
      const new_password = this.changePasswordForm.value.password;
      if (!this.uid || !this.token || !new_password) return;

      this.authService.resetPasswordConfirm({
        uid: this.uid,
        token: this.token,
        new_password
      }).subscribe({
        next: () => {
          this.router.navigate(['/auth/sign-in']);
        },
        error: (err: HttpErrorResponse) => {
          this.isLoading = false;
          let msg = 'Failed to reset password.';
          if (err.error) {
              const keys = Object.keys(err.error);
              if (keys.length > 0 && Array.isArray(err.error[keys[0]])) {
                  msg = err.error[keys[0]][0];
              }
          }
          this.errorMessage = msg;
        }
      });
    } else {
      this.changePasswordForm.markAllAsTouched();
    }
  }
}
